(() => {
  const SELECTOR = '[data-image-gallery-slider]';

  if (window.TznImageGallerySlider) {
    window.TznImageGallerySlider.initAll();
    return;
  }

  const toBoolean = (value) => value === 'true';

  const destroySlider = (section) => {
    const slider = section?.querySelector(
      '.image-gallery-slider__track'
    );

    if (slider?.imageGallerySwiper) {
      slider.imageGallerySwiper.destroy(true, true);
      slider.imageGallerySwiper = null;
    }
  };

  const initSlider = (section) => {
    if (!section || typeof window.Swiper === 'undefined') {
      return false;
    }

    const slider = section.querySelector(
      '.image-gallery-slider__track'
    );

    if (!slider || slider.imageGallerySwiper) {
      return true;
    }

    const autoPlayValue = section.dataset.autoPlay;

    const autoPlay =
      autoPlayValue === 'false'
        ? false
        : {
            delay: Number(autoPlayValue),
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };

    const showArrows =
      toBoolean(section.dataset.showArrows);

    const showDots =
      toBoolean(section.dataset.showDots);

    slider.imageGallerySwiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: Number(section.dataset.gap) || 20,
      snapToSlideEdge: true,

      centeredSlides: toBoolean(
        section.dataset.centeredSlides
      ),

      loop: toBoolean(section.dataset.loop),

      speed: 600,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      keyboard: {
        enabled: true,
        onlyInViewport: true
      },

      autoplay: autoPlay,

      navigation: showArrows
        ? {
            nextEl: slider.querySelector(
              '.image-gallery-slider__button--next'
            ),
            prevEl: slider.querySelector(
              '.image-gallery-slider__button--prev'
            )
          }
        : false,

      pagination: showDots
        ? {
            el: slider.querySelector(
              '.image-gallery-slider__pagination'
            ),
            clickable: true
          }
        : false,

      on: {
        init() {
          slider.classList.add('is-ready');
        }
      }
    });

    return true;
  };

  const initAll = (root = document) => {
    root
      .querySelectorAll(SELECTOR)
      .forEach(initSlider);
  };

  const waitForSwiper = () => {
    if (typeof window.Swiper !== 'undefined') {
      initAll();
      return;
    }

    let attempts = 0;

    const timer = window.setInterval(() => {
      attempts += 1;

      if (typeof window.Swiper !== 'undefined') {
        window.clearInterval(timer);
        initAll();
      } else if (attempts >= 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  window.TznImageGallerySlider = {
    initAll,
    initSlider,
    destroySlider
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      waitForSwiper,
      { once: true }
    );
  } else {
    waitForSwiper();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section = event.target.matches?.(SELECTOR)
        ? event.target
        : event.target.querySelector?.(SELECTOR);

      if (section && !initSlider(section)) {
        waitForSwiper();
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const section = event.target.matches?.(SELECTOR)
        ? event.target
        : event.target.querySelector?.(SELECTOR);

      destroySlider(section);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const slide = event.target.closest?.(
        '.image-gallery-slider__cell'
      );

      const slider = slide?.closest(
        '.image-gallery-slider__track'
      );

      const swiper = slider?.imageGallerySwiper;

      if (!slide || !swiper) return;

      const index = Number(
        slide.dataset.blockIndex
      );

      if (swiper.params.loop) {
        swiper.slideToLoop(index);
      } else {
        swiper.slideTo(index);
      }
    }
  );
})();